import { combineReducers } from "redux";
import { History } from "history";
import { connectRouter } from "connected-react-router";
import { registrationReducer } from "./Authorization/Registration/reducer";
import { AppReducer } from "./App/reducer";
import { ordersReducer } from "./Properties/reducer";
import { MainReducer } from "./Main/reducer";
import { PropertyReducer } from "./Story/reduser"
import homeDiary from "./HomeDiary/reduser"

const rootReducer = (history: History) =>
  combineReducers({
    profileProperty: registrationReducer,
    app: AppReducer,
    router: connectRouter(history),
    orders: ordersReducer,
    main: MainReducer,
    property: PropertyReducer,
    homeDiary: homeDiary,
  } as any);

export default rootReducer;
